import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

var HttpError = /*#__PURE__*/function (_Error) {
  function HttpError(message, status, code, subCodes, data) {
    var _this2;

    _classCallCheck(this, HttpError);

    _this2 = _callSuper(this, HttpError, [message]);
    _this2.status = status;
    _this2.message = message;
    _this2.code = code;
    _this2.subCodes = subCodes;
    _this2.name = _this2.constructor.name;
    _this2.data = data;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_this2, _this2.constructor);
    } else {
      _this2.stack = new Error(message).stack;
    }

    _this2.stack = new Error().stack;
    return _this2;
  }

  _inherits(HttpError, _Error);

  return _createClass(HttpError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export default HttpError;
//# sourceMappingURL=HttpError.js.map